// extracted by mini-css-extract-plugin
export default {"footer":"MedicalNoteCancelAutoApproveWarningPopup_footer__0e6cx","paragraph":"MedicalNoteCancelAutoApproveWarningPopup_paragraph__N1Gc4"};